const HowIMet = () => (
    <section id="how-i-met">
        <div className="container-fluid py-4 text-center gg-bg-gradient-v text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-9 col-11">
                    <h3 className="mt-3 mb-4 fw-bold">How I met Dr. Hart.</h3>
                    <p className="pt-2">
                        Alice shared a card with me.<br />
                        No logo. No website. No social media handle.
                    </p>
                    <p>
                        Just a name, a number, and her discreet voice whispering,<br />
                        <i>"He helped me. Maybe he can help you too."</i>
                    </p>
                    <p>
                        She slipped it into my palm as casually as passing a napkin.<br />
                        When she saw the look on my face after that birthday cake moment, she knew.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default HowIMet;